import {
  hasCorrectParent
} from "./chunk.7X6D52KI.js";
import {
  NoInnerEventsComponent
} from "./chunk.54YXW2TU.js";
import {
  emit
} from "./chunk.HM4ZRC4T.js";
import {
  focusVisibleSelector
} from "./chunk.ZX7YPA4S.js";
import {
  watch
} from "./chunk.HBM5K2JV.js";
import {
  __decorateClass,
  component_styles_default,
  theme_styles_default
} from "./chunk.U4VUMZVF.js";

// src/utilities/base-list-item.ts
import { html } from "lit";
import { property, query } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// ../../node_modules/@lit/reactive-element/css-tag.js
var t = window.ShadowRoot && (window.ShadyCSS === void 0 || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
var e = Symbol();
var n = /* @__PURE__ */ new Map();
var s = class {
  constructor(t2, n3) {
    if (this._$cssResult$ = true, n3 !== e)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t2;
  }
  get styleSheet() {
    let e3 = n.get(this.cssText);
    return t && e3 === void 0 && (n.set(this.cssText, e3 = new CSSStyleSheet()), e3.replaceSync(this.cssText)), e3;
  }
  toString() {
    return this.cssText;
  }
};
var o = (t2) => new s(typeof t2 == "string" ? t2 : t2 + "", e);
var r = (t2, ...n3) => {
  const o3 = t2.length === 1 ? t2[0] : n3.reduce((e3, n4, s3) => e3 + ((t3) => {
    if (t3._$cssResult$ === true)
      return t3.cssText;
    if (typeof t3 == "number")
      return t3;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + t3 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(n4) + t2[s3 + 1], t2[0]);
  return new s(o3, e);
};
var i = (e3, n3) => {
  t ? e3.adoptedStyleSheets = n3.map((t2) => t2 instanceof CSSStyleSheet ? t2 : t2.styleSheet) : n3.forEach((t2) => {
    const n4 = document.createElement("style"), s3 = window.litNonce;
    s3 !== void 0 && n4.setAttribute("nonce", s3), n4.textContent = t2.cssText, e3.appendChild(n4);
  });
};
var S = t ? (t2) => t2 : (t2) => t2 instanceof CSSStyleSheet ? ((t3) => {
  let e3 = "";
  for (const n3 of t3.cssRules)
    e3 += n3.cssText;
  return o(e3);
})(t2) : t2;

// ../../node_modules/@lit/reactive-element/reactive-element.js
var s2;
var e2 = window.trustedTypes;
var r2 = e2 ? e2.emptyScript : "";
var h = window.reactiveElementPolyfillSupport;
var o2 = { toAttribute(t2, i2) {
  switch (i2) {
    case Boolean:
      t2 = t2 ? r2 : null;
      break;
    case Object:
    case Array:
      t2 = t2 == null ? t2 : JSON.stringify(t2);
  }
  return t2;
}, fromAttribute(t2, i2) {
  let s3 = t2;
  switch (i2) {
    case Boolean:
      s3 = t2 !== null;
      break;
    case Number:
      s3 = t2 === null ? null : Number(t2);
      break;
    case Object:
    case Array:
      try {
        s3 = JSON.parse(t2);
      } catch (t3) {
        s3 = null;
      }
  }
  return s3;
} };
var n2 = (t2, i2) => i2 !== t2 && (i2 == i2 || t2 == t2);
var l = { attribute: true, type: String, converter: o2, reflect: false, hasChanged: n2 };
var a = class extends HTMLElement {
  constructor() {
    super(), this._$Et = /* @__PURE__ */ new Map(), this.isUpdatePending = false, this.hasUpdated = false, this._$Ei = null, this.o();
  }
  static addInitializer(t2) {
    var i2;
    (i2 = this.l) !== null && i2 !== void 0 || (this.l = []), this.l.push(t2);
  }
  static get observedAttributes() {
    this.finalize();
    const t2 = [];
    return this.elementProperties.forEach((i2, s3) => {
      const e3 = this._$Eh(s3, i2);
      e3 !== void 0 && (this._$Eu.set(e3, s3), t2.push(e3));
    }), t2;
  }
  static createProperty(t2, i2 = l) {
    if (i2.state && (i2.attribute = false), this.finalize(), this.elementProperties.set(t2, i2), !i2.noAccessor && !this.prototype.hasOwnProperty(t2)) {
      const s3 = typeof t2 == "symbol" ? Symbol() : "__" + t2, e3 = this.getPropertyDescriptor(t2, s3, i2);
      e3 !== void 0 && Object.defineProperty(this.prototype, t2, e3);
    }
  }
  static getPropertyDescriptor(t2, i2, s3) {
    return { get() {
      return this[i2];
    }, set(e3) {
      const r3 = this[t2];
      this[i2] = e3, this.requestUpdate(t2, r3, s3);
    }, configurable: true, enumerable: true };
  }
  static getPropertyOptions(t2) {
    return this.elementProperties.get(t2) || l;
  }
  static finalize() {
    if (this.hasOwnProperty("finalized"))
      return false;
    this.finalized = true;
    const t2 = Object.getPrototypeOf(this);
    if (t2.finalize(), this.elementProperties = new Map(t2.elementProperties), this._$Eu = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
      const t3 = this.properties, i2 = [...Object.getOwnPropertyNames(t3), ...Object.getOwnPropertySymbols(t3)];
      for (const s3 of i2)
        this.createProperty(s3, t3[s3]);
    }
    return this.elementStyles = this.finalizeStyles(this.styles), true;
  }
  static finalizeStyles(i2) {
    const s3 = [];
    if (Array.isArray(i2)) {
      const e3 = new Set(i2.flat(1 / 0).reverse());
      for (const i3 of e3)
        s3.unshift(S(i3));
    } else
      i2 !== void 0 && s3.push(S(i2));
    return s3;
  }
  static _$Eh(t2, i2) {
    const s3 = i2.attribute;
    return s3 === false ? void 0 : typeof s3 == "string" ? s3 : typeof t2 == "string" ? t2.toLowerCase() : void 0;
  }
  o() {
    var t2;
    this._$Ep = new Promise((t3) => this.enableUpdating = t3), this._$AL = /* @__PURE__ */ new Map(), this._$Em(), this.requestUpdate(), (t2 = this.constructor.l) === null || t2 === void 0 || t2.forEach((t3) => t3(this));
  }
  addController(t2) {
    var i2, s3;
    ((i2 = this._$Eg) !== null && i2 !== void 0 ? i2 : this._$Eg = []).push(t2), this.renderRoot !== void 0 && this.isConnected && ((s3 = t2.hostConnected) === null || s3 === void 0 || s3.call(t2));
  }
  removeController(t2) {
    var i2;
    (i2 = this._$Eg) === null || i2 === void 0 || i2.splice(this._$Eg.indexOf(t2) >>> 0, 1);
  }
  _$Em() {
    this.constructor.elementProperties.forEach((t2, i2) => {
      this.hasOwnProperty(i2) && (this._$Et.set(i2, this[i2]), delete this[i2]);
    });
  }
  createRenderRoot() {
    var t2;
    const s3 = (t2 = this.shadowRoot) !== null && t2 !== void 0 ? t2 : this.attachShadow(this.constructor.shadowRootOptions);
    return i(s3, this.constructor.elementStyles), s3;
  }
  connectedCallback() {
    var t2;
    this.renderRoot === void 0 && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(true), (t2 = this._$Eg) === null || t2 === void 0 || t2.forEach((t3) => {
      var i2;
      return (i2 = t3.hostConnected) === null || i2 === void 0 ? void 0 : i2.call(t3);
    });
  }
  enableUpdating(t2) {
  }
  disconnectedCallback() {
    var t2;
    (t2 = this._$Eg) === null || t2 === void 0 || t2.forEach((t3) => {
      var i2;
      return (i2 = t3.hostDisconnected) === null || i2 === void 0 ? void 0 : i2.call(t3);
    });
  }
  attributeChangedCallback(t2, i2, s3) {
    this._$AK(t2, s3);
  }
  _$ES(t2, i2, s3 = l) {
    var e3, r3;
    const h2 = this.constructor._$Eh(t2, s3);
    if (h2 !== void 0 && s3.reflect === true) {
      const n3 = ((r3 = (e3 = s3.converter) === null || e3 === void 0 ? void 0 : e3.toAttribute) !== null && r3 !== void 0 ? r3 : o2.toAttribute)(i2, s3.type);
      this._$Ei = t2, n3 == null ? this.removeAttribute(h2) : this.setAttribute(h2, n3), this._$Ei = null;
    }
  }
  _$AK(t2, i2) {
    var s3, e3, r3;
    const h2 = this.constructor, n3 = h2._$Eu.get(t2);
    if (n3 !== void 0 && this._$Ei !== n3) {
      const t3 = h2.getPropertyOptions(n3), l2 = t3.converter, a2 = (r3 = (e3 = (s3 = l2) === null || s3 === void 0 ? void 0 : s3.fromAttribute) !== null && e3 !== void 0 ? e3 : typeof l2 == "function" ? l2 : null) !== null && r3 !== void 0 ? r3 : o2.fromAttribute;
      this._$Ei = n3, this[n3] = a2(i2, t3.type), this._$Ei = null;
    }
  }
  requestUpdate(t2, i2, s3) {
    let e3 = true;
    t2 !== void 0 && (((s3 = s3 || this.constructor.getPropertyOptions(t2)).hasChanged || n2)(this[t2], i2) ? (this._$AL.has(t2) || this._$AL.set(t2, i2), s3.reflect === true && this._$Ei !== t2 && (this._$E_ === void 0 && (this._$E_ = /* @__PURE__ */ new Map()), this._$E_.set(t2, s3))) : e3 = false), !this.isUpdatePending && e3 && (this._$Ep = this._$EC());
  }
  async _$EC() {
    this.isUpdatePending = true;
    try {
      await this._$Ep;
    } catch (t3) {
      Promise.reject(t3);
    }
    const t2 = this.scheduleUpdate();
    return t2 != null && await t2, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var t2;
    if (!this.isUpdatePending)
      return;
    this.hasUpdated, this._$Et && (this._$Et.forEach((t3, i3) => this[i3] = t3), this._$Et = void 0);
    let i2 = false;
    const s3 = this._$AL;
    try {
      i2 = this.shouldUpdate(s3), i2 ? (this.willUpdate(s3), (t2 = this._$Eg) === null || t2 === void 0 || t2.forEach((t3) => {
        var i3;
        return (i3 = t3.hostUpdate) === null || i3 === void 0 ? void 0 : i3.call(t3);
      }), this.update(s3)) : this._$EU();
    } catch (t3) {
      throw i2 = false, this._$EU(), t3;
    }
    i2 && this._$AE(s3);
  }
  willUpdate(t2) {
  }
  _$AE(t2) {
    var i2;
    (i2 = this._$Eg) === null || i2 === void 0 || i2.forEach((t3) => {
      var i3;
      return (i3 = t3.hostUpdated) === null || i3 === void 0 ? void 0 : i3.call(t3);
    }), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t2)), this.updated(t2);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$Ep;
  }
  shouldUpdate(t2) {
    return true;
  }
  update(t2) {
    this._$E_ !== void 0 && (this._$E_.forEach((t3, i2) => this._$ES(i2, this[i2], t3)), this._$E_ = void 0), this._$EU();
  }
  updated(t2) {
  }
  firstUpdated(t2) {
  }
};
a.finalized = true, a.elementProperties = /* @__PURE__ */ new Map(), a.elementStyles = [], a.shadowRootOptions = { mode: "open" }, h == null || h({ ReactiveElement: a }), ((s2 = globalThis.reactiveElementVersions) !== null && s2 !== void 0 ? s2 : globalThis.reactiveElementVersions = []).push("1.2.1");

// src/utilities/base-list-item.ts
var LIST_ITEM_SELECTION_INDICARTORS = ["YOTPO-CHECKBOX", "YOTPO-RADIO"];
var BaseListItem = class extends NoInnerEventsComponent {
  constructor() {
    super(...arguments);
    this.customEvents = ["yotpo-request-change" /* requestChange */];
    this._checked = false;
    this.label = "";
    this.value = "";
    this.multiSelectable = false;
    this.radio = false;
    this.disabled = false;
  }
  get checked() {
    return this._checked;
  }
  set checked(value) {
    this.setChecked(value);
  }
  setChecked(value, { emitEvent } = { emitEvent: true }) {
    if (this._checked === value) {
      return;
    }
    const oldValue = this._checked;
    this._checked = value;
    if (this.multiSelectable && this.listItemCheckbox) {
      this.listItemCheckbox.checked = this._checked;
    } else if (!this.multiSelectable && this.radio && this.listItemRadio) {
      this.listItemRadio.checked = this._checked;
    }
    if (emitEvent) {
      emit(this, "yotpo-request-change" /* requestChange */);
    }
    this.requestUpdate("checked", oldValue);
  }
  firstUpdated() {
    this.setAttribute("role", "listitem");
  }
  handleDisabledChange() {
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  handleClick(e3) {
    var _a;
    if (LIST_ITEM_SELECTION_INDICARTORS.includes((_a = e3.target) == null ? void 0 : _a.tagName)) {
      return;
    }
    emit(this, "yotpo-request-change" /* requestChange */);
  }
  handleCheckboxRequestChange(e3) {
    e3.stopPropagation();
    emit(this, "yotpo-request-change" /* requestChange */);
  }
  handleCheckboxChange(e3) {
    e3.preventDefault();
    e3.stopPropagation();
  }
  handleRadioChange(e3) {
    e3.stopPropagation();
    emit(this, "yotpo-request-change" /* requestChange */);
  }
  renderListItem(listItemContent) {
    if (!hasCorrectParent(this, "yotpo-list")) {
      return html``;
    }
    return html`
			<div
				part="base"
				aria-selected=${this.checked ? "true" : "false"}
				class=${classMap({
      "list-item": true,
      "list-item--checked": this.checked,
      "list-item--disabled": this.disabled,
      "list-item--single-selectable": !this.multiSelectable && !this.radio
    })}
				@click=${this.handleClick}
			>
				${this.multiSelectable ? html` <yotpo-checkbox
							part="checkbox"
							class="list-item__selection-indicator list-item__checkbox"
							tabindex="-1"
							?checked=${this.checked}
							?disabled=${this.disabled}
							@yotpo-request-change=${this.handleCheckboxRequestChange}
							@yotpo-change=${this.handleCheckboxChange}
					  ></yotpo-checkbox>` : this.radio ? html` <yotpo-radio
							part="radio"
							class="list-item__selection-indicator list-item__radio"
							tabindex="-1"
							?checked=${this.checked}
							?disabled=${this.disabled}
							@yotpo-change=${this.handleRadioChange}
					  ></yotpo-radio>` : ""}
				${listItemContent}

				<span part="suffix" class="list-item__suffix">
					<slot name="suffix"></slot>
				</span>
			</div>
		`;
  }
};
__decorateClass([
  query(".list-item")
], BaseListItem.prototype, "listItem", 2);
__decorateClass([
  query(".list-item__checkbox")
], BaseListItem.prototype, "listItemCheckbox", 2);
__decorateClass([
  query(".list-item__radio")
], BaseListItem.prototype, "listItemRadio", 2);
__decorateClass([
  property({ reflect: true })
], BaseListItem.prototype, "label", 2);
__decorateClass([
  property({ reflect: true })
], BaseListItem.prototype, "value", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], BaseListItem.prototype, "multiSelectable", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], BaseListItem.prototype, "radio", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], BaseListItem.prototype, "checked", 1);
__decorateClass([
  property({ type: Boolean, reflect: true })
], BaseListItem.prototype, "disabled", 2);
__decorateClass([
  watch("disabled")
], BaseListItem.prototype, "handleDisabledChange", 1);
var listItemStyles = r`
	${theme_styles_default}
	${component_styles_default}

:host {
		display: block;
		width: 100%;
		outline: none;
		border: 0;
	}

	.list-item {
		position: relative;
		display: flex;
		align-items: center;
		background-color: var(--yotpo-input-background-color);
		padding: var(--yotpo-input-spacing);
		text-align: left;
		user-select: none;
		white-space: nowrap;
		cursor: pointer;
		outline: none;
		width: 100%;
	}

	.list-item__labels {
		padding: 0 var(--yotpo-input-spacing);
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.list-item .list-item__label,
	.list-item .list-item__sublabel {
		flex: 0 0 auto;
		max-width: 100%;
		height: auto;
		text-overflow: clip;
		white-space: normal;
	}

	.list-item .list-item__prefix,
	.list-item .list-item__suffix,
	.list-item .list-item__status {
		flex: 0 0 auto;
		display: flex;
		align-items: center;
	}

	.list-item:not(.list-item--single-selectable.list-item--checked, .list-item--disabled, .list-item--locked)
		.list-item__prefix,
	.list-item:not(.list-item--single-selectable.list-item--checked, .list-item--disabled, .list-item--locked)
		.list-item__suffix {
		color: var(--yotpo-font-color-light-secondary);
	}

	.list-item .list-item__prefix ::slotted(*),
	.list-item .list-item__status {
		margin-left: var(--yotpo-input-spacing);
	}

	.list-item .list-item__suffix ::slotted(*) {
		margin-right: var(--yotpo-input-spacing);
	}

	.list-item.list-item--disabled {
		cursor: not-allowed;
	}

	.list-item.list-item--disabled:not(.list-item--single-selectable.list-item--checked) {
		color: var(--yotpo-color-disabled);
	}

	:host(:hover:not([aria-disabled='true']))
		.list-item:not(.list-item--single-selectable.list-item--checked, .list-item--disabled, .list-item--locked),
	:host(${focusVisibleSelector}:not([aria-disabled='true']))
		.list-item:not(.list-item--single-selectable.list-item--checked, .list-item--disabled, .list-item--locked) {
		background-color: var(--yotpo-color-brand-10);
	}

	.list-item--single-selectable.list-item--checked {
		background-color: var(--yotpo-color-brand-60);
		color: var(--yotpo-font-color-dark-primary);
	}

	.list-item--single-selectable.list-item--checked.list-item--disabled {
		background-color: var(--yotpo-color-general-60);
	}

	:host(:hover:not([aria-disabled='true']))
		.list-item--single-selectable.list-item--checked:not(.list-item--disabled),
	:host(${focusVisibleSelector}:not([aria-disabled='true']))
		.list-item--single-selectable.list-item--checked:not(.list-item--disabled) {
		background-color: var(--yotpo-color-brand-50);
	}

	.list-item .list-item__selection-indicator {
		display: flex;
		margin-left: var(--yotpo-input-spacing);
		border-radius: var(--yotpo-input-border-radius);
		height: var(--yotpo-toggle-size);
		align-items: center;
		font-size: inherit;
		transition: var(--yotpo-transition-fast) border-color, var(--yotpo-transition-fast) background-color,
			var(--yotpo-transition-fast) color, var(--yotpo-transition-fast) box-shadow;
	}

	:host(:focus) .list-item .list-item__selection-indicator {
		box-shadow: var(--yotpo-focus-global);
	}
`;

export {
  BaseListItem,
  listItemStyles
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
